import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import RecipeAdjustmentForm from './RecipeAdjustmentForm'; // 新しいコンポーネントをインポート

const RecipeDetail = ({ api, isAuthenticated }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [recipe, setRecipe] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecipe = async () => {
      try {
        const response = await api.get(`/recipe/${id}`);
        setRecipe(response.data);
      } catch (err) {
        console.error('レシピ詳細取得エラー:', err);
        setError('レシピ詳細の取得中にエラーが発生しました。');
      } finally {
        setLoading(false);
      }
    };
    fetchRecipe();
  }, [id, api]);

  const renderAI = (recipeData) => {
    const ai = recipeData.ai_adjusted_recipe;
    const raw = recipeData.ai_adjusted_recipe_raw;
    const isObject = ai && typeof ai === 'object' && !Array.isArray(ai);

    if (isObject) {
      const {
        servings,
        total_time_min,
        ingredients = [],
        steps = [],
        tips = [],
      } = ai;

      return (
        <div style={{ fontSize: '1em', lineHeight: '1.6' }}>
          <div style={{ margin: '15px 0', color: '#333', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
            {Number.isFinite(servings) && <span style={{ marginRight: '20px' }}>人数: {servings}人分</span>}
            {Number.isFinite(total_time_min) && <span>時間: 約{total_time_min}分</span>}
          </div>

          {ingredients.length > 0 && (
            <>
              <h3 style={{ margin: '20px 0 10px' }}>材料</h3>
              <ul style={{ paddingLeft: '25px', margin: 0, listStyleType: 'disc' }}>
                {ingredients.map((ing, idx) => {
                  const quantity = ing.quantity ?? '';
                  const unitBefore = ing.unit_before ?? '';
                  const unit = ing.unit ?? '';
                  const note = ing.note ? `（${ing.note}）` : '';

                  let displayQuantityAndUnit;
                  if (unitBefore !== '') {
                    displayQuantityAndUnit = `${unitBefore}${quantity !== '' ? ` ${quantity}` : ''}`;
                  } else {
                    displayQuantityAndUnit = `${quantity !== '' ? ` ${quantity}` : ''}${unit}`;
                  }

                  return (
                    <li key={idx} style={{ marginBottom: '8px' }}>
                      {ing.name}{displayQuantityAndUnit !== '' ? ` ${displayQuantityAndUnit}` : ''}{note}
                    </li>
                  );
                })}
              </ul>
            </>
          )}

          {steps.length > 0 && (
            <>
              <h3 style={{ margin: '25px 0 10px' }}>作り方</h3>
              <ol style={{ paddingLeft: '25px', margin: 0, listStyleType: 'decimal' }}>
                {steps.map((s, idx) => (
                  <li key={idx} style={{ marginBottom: '10px', whiteSpace: 'pre-wrap' }}>{s}</li>
                ))}
              </ol>
            </>
          )}

          {tips.length > 0 && (
            <>
              <h3 style={{ margin: '25px 0 10px' }}>ポイント</h3>
              <ul style={{ paddingLeft: '25px', margin: 0, listStyleType: 'disc' }}>
                {tips.map((t, idx) => (
                  <li key={idx} style={{ marginBottom: '8px', whiteSpace: 'pre-wrap' }}>{t}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      );
    }

    const text = typeof ai === 'string' ? ai : (raw || '');
    return <p style={{ whiteSpace: 'pre-wrap', fontSize: '1em' }}>{text}</p>;
  };

  if (loading) return <p>レシピを読み込み中...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;
  if (!recipe) return <p>レシピが見つかりませんでした。</p>;

  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px', border: '1px solid #eee', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
      <button
        onClick={() => navigate('/')}
        style={{
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          padding: '10px 15px',
          borderRadius: '5px',
          cursor: 'pointer',
          marginBottom: '20px',
          fontSize: '1em'
        }}
      >
        ← レシピ一覧に戻る
      </button>
      <h1 style={{ textAlign: 'center', color: '#333', marginBottom: '20px' }}>{recipe.title}</h1>
      <img
        src={recipe.image_path}
        alt={recipe.title}
        style={{ width: '100%', height: '400px', objectFit: 'cover', borderRadius: '8px', marginBottom: '20px' }}
      />

      {recipe.status === 'processing' && (
        <p style={{ fontSize: '1.1em', color: '#555', textAlign: 'center' }}>状態: AI処理中</p>
      )}

      {recipe.status === 'completed' && renderAI(recipe)}

      {recipe.status === 'error' && (
        <p style={{ color: 'red', fontSize: '1.1em', textAlign: 'center' }}>レシピの処理中にエラーが発生しました。</p>
      )}

      {isAuthenticated && <RecipeAdjustmentForm recipeId={id} api={api} />}
    </div>
  );
};

export default RecipeDetail;
